module.exports = __webpack_public_path__ + "img/three.3e08c8bd.png";